<template>
  <div class="business-contacts">
    <div class="module-item-style" v-if="role">
      <div class="module-item-title-border-left">团队联系人</div>
      <el-form :model="contactsForm" :rules="contactsFormRules" ref="contactsForm" label-width="100px" class="business-contacts-form">
        <el-form-item
            label="姓名："
            prop="link" >
          <el-input type="text" v-model="contactsForm.link" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item
            label="电话："
            prop="mobile">
          <el-input type="text" v-model="contactsForm.mobile"  autocomplete="off"  placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item
            label="邮箱："
            prop="email">
          <el-input type="text" v-model="contactsForm.email" autocomplete="off"  placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item>
          <span class="wl-btn" @click="editContacts('contactsForm')">确定 </span>
        </el-form-item>
      </el-form>
    </div>
    <div class="no-auth-view module-item-style" v-else>
      只有超级管理员可查看
    </div>
  </div>
</template>

<script>
  export default {
    name: 'business-contacts',
    data() {
      return {
        contactsForm:{
          link: '',
          mobile:'',
          email:''
        },
        contactsFormRules:{
          link: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '请输入电话', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' }
          ],
        }
      }
    },
    created(){
      this.getContacts()
    },
    mounted() {

    },
    computed:{
      role(){
        let serviceRole = this.$store.state.user.roles
        if(serviceRole == 0){
          return true
        }else {
          return  false
        }
      },
    },
    methods: {
      getContacts(){
        this.$http.getContactsAPI().then( res => {
          if(res.status == 1){
            this.contactsForm = res.data
          }
        })
      },
      editContacts(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let postData = this.contactsForm
            this.$http.editContactsAPI(postData).then( res => {
              if(res.status){
                this.$message({
                  message: res.msg,
                  type: 'success',
                })

              }else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }
            })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .business-contacts{
    padding-top: 15px;
    .business-contacts-form{
      width: 300px;
      padding-top: 47px;
    }
  }

</style>
